import Icon, { IconProps as IconPropsInternal } from "./Icon";

export type IconProps = IconPropsInternal;
export default Icon;
